import StaffService from '@/services/StaffService';
import { SET_STAFF_STATION } from '../action-types';
import Vue from 'vue';

// state
const localState = {
  autoLoad: {
    loading: false,
    loader: StaffService.getAll,
    emptyMap: {},
  },
  staffs: {},
  roles: {},
  userGroups: {},
  staffPage: null,
};

// getters
const localGetters = {
  printStaffColor: (state, getters) => (staff) => {
    const location = getters.getMap('user', true).location;
    return (staff.location && staff.location == location.id) ? '#41b14f' : '#FCD5C4';
  },
  checkStaffLocation: (state, getters) => (staff) => {
    const location = getters.getMap('user', true).location;
    return !!((staff.location && staff.location == location.id));
  },
  printStaffName: state => (id) => {
    const staff = state.staffs[id];
    return staff ? `${staff.firstName} ${staff.lastName}` : '';
  },
  checkStaff: (state, getters) => (value, property = 'id') => {
    const staffs = getters.getArray('staffs');
    const user = getters.getMap('user');
    const staff = staffs.find(staff => staff[property] && staff[property] == value);
    if (!staff) {
      return {
        valid: false,
        data: {
          message: Vue.prototype.$gettext('Staff not found'),
        },
      };
    }
    if (staff.location !== user.location.id) {
      return {
        valid: false,
        data: {
          message: Vue.prototype.$gettext('Staff not signed in '),
        },
      };
    }
    return { valid: true };
  },
};

// actions
const actions = {
  async [SET_STAFF_STATION](context, data) {
    await StaffService.setStaffStation(data.staffId, data.station);
  },
};

export default {
  state: localState,
  getters: localGetters,
  actions,
};
